import { db } from '../utils/firebase.js';
import { doc, getDoc, getDocs, updateDoc, collection, query, where } from "firebase/firestore";


export const GetEnemyList = async (chapter) => {
    const docRef = doc(db, "gameTracking", "isofarianGuard", "enemyIndex", chapter);
    const docSnap = await getDoc(docRef);
    return docSnap.data();
}